
import { Vue, Component } from 'vue-property-decorator';
import userx from '@/store/modules/userx';
@Component
export default class AppNavbar extends Vue {
	get user() {
		return userx.user;
	}
	get signinState() {
		return userx.signinState;
	}
	get loginStatus() {
		return userx.loginStatus;
	}

	get displayName() {
		if (!userx.user) { return ''; }
		if (userx.user.displayName !== '') {
			return userx.displayName;
		}
		return userx.user.email;
	}

	get needCompleteRegistration() {
		return userx.needCompleteRegistration;
	}
	public async created()	{
		console.log('AppNavBar.vue created');
	}
	public signOut() {
		userx.signOut();
	}
}
